export default "__VITE_ASSET__c0a2f0a1__"